import BlogSidebarMobile from "@/components/Blog/BlogSidebar/BlogSidebarMobile";
import { clsx } from "@cgc/ui/utils/clsx";
import React from "react";
import BlogSidebarDesktop from "./BlogSidebar";
import type { BlogSidebarProps } from "./types";

type ClassNamesProps = {
  classNames?: {
    mobile?: string;
    desktop?: string;
  };
};
const BlogSidebar: React.FC<BlogSidebarProps & ClassNamesProps> = ({
  classNames,
  ...props
}) => {
  return (
    <>
      <BlogSidebarMobile
        {...props}
        className={clsx(classNames?.mobile, "block lg:hidden")}
      />
      <BlogSidebarDesktop
        {...props}
        className={clsx(classNames?.desktop, "hidden lg:block")}
      />
    </>
  );
};

export default BlogSidebar;
